import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { InvalidTokenCard, ResetPasswordForm } from "@/components/auth/reset-password-form";
import { noIndexSeo } from "@/lib/seo";

const searchSchema = z
	.object({
		token: z.string().optional(),
	})
	.optional();

export const Route = createFileRoute("/(landing)/(auth)/reset-password")({
	validateSearch: searchSchema,
	component: RouteComponent,
	head: ({ match }) =>
		noIndexSeo({
			title: "Reset Password | StudyOS",
			description: "Set a new password for your StudyOS account.",
			pathname: match.pathname,
		}),
});

function RouteComponent() {
	const { token } = Route.useSearch() || {};

	return (
		<div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
			<div className="w-full max-w-sm">
				{token ? <ResetPasswordForm token={token} /> : <InvalidTokenCard />}
			</div>
		</div>
	);
}
